import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import FeedbackActions from '../../feedback/FeedbackActions';

 class Home extends Component {
   constructor(props){
     super(props);
   }

  render() {
    return (
      <div className="view">
        <div className="row">
          <div style={{marginTop:"10em"}} className="offset-xl-2 offset-lg-2 offset-md-1 col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-12">
            <h3>{this.props.app.language.map !== null ? this.props.app.language.map.header.home.header1 : ""}</h3>
            <p>
              {this.props.app.language.map !== null ?
                (
                  this.props.app.language.map.text.home.split('\n').map((item, key) => {
                    if(item.indexOf("[mailto]") > -1){
                        let aIdx = item.indexOf("[mailto]");
                        let bIdx = item.lastIndexOf("[mailto]");
                        let itemSplicedA = item.split("[mailto]");
                        let mailto = <a href="mailto:abciteam@ackerschott.eu">abciteam@ackerschott.eu</a>;
                        return <span key={"h_t_" + key}>{itemSplicedA[0]}{mailto}{itemSplicedA[1]}<br/></span>
                    }else 
                      return <span key={"h_t_" + key}>{item}<br/></span>
                  }
                ))
                :
                 ""
              }
            </p>
          </div>
          <div style={{marginTop:"4rem", marginBottom:"2rem", textAlign:"center"}} className="offset-xl-2 offset-lg-2 offset-md-1 col-xl-8 col-lg-9 col-md-10 col-sm-11 col-xs-12">
            {
              this.props.app.language.map !== null ?
              <Link to={"/" + this.props.app.language.active + "/feedback/" + this.props.app.token.token} onClick={this.props.indicator.interval == null && this.props.indicator.timer === 0 ? (e) => this.props.setIndicatorInitial(180000) : null} className="btn btn-outline-primary btn-lg">{this.props.app.language.map.labels.home.continue}</Link>
              :
              null
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  app: state.application,
  indicator: state.feedback.indicator
});

const mapDispatchToProps = (dispatch) => ({
  setIndicatorInitial: (timespan) => dispatch(FeedbackActions.setIndicatorInitial(timespan)),
  setIndicatorTimer: (timer, strokeDashoffset) => dispatch(FeedbackActions.setIndicatorTimer(timer, strokeDashoffset))
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/modules/home/view/Home.js